import { Injectable } from '@angular/core';
import { concat, Observable } from 'rxjs';
import { ProjectApiService } from './project-api.service';
import { UserApiService } from './user-api.service';

@Injectable()
export class ProjectResolver  {
  constructor(
    private projectApiService: ProjectApiService,
    private userApiService: UserApiService,
  ) {}

  public resolve(): Observable<any> | Promise<any> | any {
    return concat(this.userApiService.getUser(), this.projectApiService.getProject());
  }
}
